import React from 'react';
export const PanelHeader = ({ title, subtitle, icon: Icon, actions, titleExtra, topRounded = false, style }) => {
    return (React.createElement("div", { style: style, className: `flex items-center justify-between p-3 f-bg-gradient f-border-b ${topRounded ? 'rounded-t-xl' : ''}` },
        React.createElement("div", { className: "flex items-center" },
            Icon && React.createElement(Icon, { className: "w-4 h-4 fluid-primary-color mr-2" }),
            React.createElement("div", { className: "flex flex-col" },
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("h2", { className: "font-semibold f-text" }, title),
                    titleExtra),
                subtitle && React.createElement("span", { className: "text-xs text-gray-500" }, subtitle))),
        actions && (React.createElement("div", { className: "flex items-center" }, actions))));
};
